
   // Wishlist feature: Add or remove the current product from the wishlist
    // function toggleWishlist() {
    $(document).on("click",".wishlist_button",function() {
     let phandle = $(this).attr("handle");
     let pid = $(this).data("id");
        const pdpData = {
            phandle: phandle,
            pid: pid
        };

        let wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];
        const isAlreadyInWishlist = wishlistData.some(item => item.pid === pdpData.pid);
        const wishlistButton = $(this);

        if (!isAlreadyInWishlist) {
            wishlistData.push(pdpData);
            localStorage.setItem('wishlist', JSON.stringify(wishlistData));
            // alert('Product added to wishlist:', pdpData.pid);
            wishlistButton.addClass("active");
        } else {
            wishlistData = wishlistData.filter(item => item.pid !== pdpData.pid);
            localStorage.setItem('wishlist', JSON.stringify(wishlistData));
            // alert('Product removed from wishlist:', pdpData.pid);
            wishlistButton.removeClass("active");
        }
        const wishlistBlock = document.querySelector('.js-wishlistBlock');
        if(wishlistBlock){
         wishlistButton.closest('li').remove();
        }
        // Update the display after modifying the wishlist
        displayWishlist();
    });

$(document).on('click', '.card .quick-add',function(){
  setTimeout(function(){
    console.log("clicked");
        const wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];

    // Set the initial button text based on whether the product is in the wishlist or not
    const wishlistButton = document.querySelector('.wishlist_button'); // Use querySelector instead of getElementsByClassName
    if (wishlistData.length>0) {
       wishlistData.forEach(function (item,index) {
         $('.wishlist_button[data-id="'+item.pid+'"]').addClass("active");
      })
    } else {
        console.error('Element with class "wishlist_button" not found');
    }
},5000);
});


    // Remove the specified product from the wishlist
    function removeFromWishlist(productTitle) {
        let wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];
        wishlistData = wishlistData.filter(item => item.productTitle !== productTitle);
        localStorage.setItem('wishlist', JSON.stringify(wishlistData));
        // Update the display after removing from the wishlist
          alert("removed worked");
        displayWishlist(pdpData);
    }

    // Display wishlist items
    function displayWishlist(pdpData) {
        const wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];
       document.querySelector('.wishlist_icon').innerHTML = wishlistData.length;
        if (wishlistData.length === 0) {
            console.log('Wishlist is empty');
            return;
        }
          const selected_option= wishlistData.map((item)=>{
            return item.phandle; 
          });
        const wishlistBlock = document.querySelector('.js-wishlistBlock');

        // Add a check to ensure the element is not null before setting innerHTML
        if (wishlistBlock) {
          var url = window.location.href;
          var match = url.includes("?&"+selected_option);
          if(match == false){
               window.location.href=window.location.pathname+"?&"+selected_option;
          }else{
            console.log(url);
              $.ajax({
                 url:url,
                 type:'GET',
                 success: function(data){
                   $('.js-wishlistBlock').html($(data).find('.js-wishlistBlock').html());
                     // console.log($(data).find('.js-wishlistBlock').html());
                     wishlistData.forEach(function (item,index) {
                         $('.wishlist_button[data-id="'+item.pid+'"]').addClass("active");
                          $('li[li--handle="'+item.phandle+'"]').removeClass("hidden");
                    })
                 }
              });
            
            const data = '?&'+selected_option;
            var new_url = url.replace(data,'');
            window.history.replaceState("", "", window.location.pathname+"?&"+selected_option);
          }
            // wishlistBlock.innerHTML = wishlistHtml;
        } else {
            console.error('Element with class "js-wishlistBlock" not found');
        }
    }

   // Execute this function on DOM content load
document.addEventListener('DOMContentLoaded', function () {
    // Fetch the wishlist data from localStorage
    const wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];

    // Set the initial button text based on whether the product is in the wishlist or not
    const wishlistButton = document.querySelector('.wishlist_button'); // Use querySelector instead of getElementsByClassName
    if (wishlistData.length>0) {
       wishlistData.forEach(function (item,index) {
         $('.wishlist_button[data-id="'+item.pid+'"]').addClass("active");
      })
    } else {
        console.error('Element with class "wishlist_button" not found');
    }

    // Display wishlist items
    displayWishlist();
});

